import { SET_MODE, MOUSE_ACTION, TOUCH_ACTION } from '../actionTypes'
import { LOCATION_CHANGE } from 'react-router-redux'
import { showAlert } from './alerts'
import i18n from 'i18n'
import ReactGA from 'react-ga'
import { currentBlockIdSelector } from '../selectors/selectors'
import { VIEWER, COMMENTER, EDITOR } from '../../constants'
import { accessLevelSelector } from '../selectors/accessSelectors'

const levels = {
  view: VIEWER,
  discuss: COMMENTER,
  edit: EDITOR
}

export const setMode = mode => (dispatch, getState) => {
  const state = getState()
  if (mode === 'edit') {
    // no editing without mouse
    if (!state.app.hasMouse)
      return dispatch(showAlert(null, i18n.t('alert.noTouchEdit')))
    // no editing in single-block view
    if (currentBlockIdSelector(state)) return
  }

  // check permissions
  if (accessLevelSelector(state) < levels[mode]) return

  return dispatch({ type: SET_MODE, payload: { mode } })
}
export const toggleMode = mode => (dispatch, getState) => {
  // if mode is currently set, go to view
  if (mode === getState().app.mode) return dispatch(setMode('view'))
  // other wise set mode
  return dispatch(setMode(mode))
}

export const gotMouseAction = () => ({ type: MOUSE_ACTION })
export const gotTouchAction = () => ({ type: TOUCH_ACTION })

let hackyDedupAnalytics  // TODO less hacky

const initialState = { mode: 'view' }
export const appReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case MOUSE_ACTION:
      return { ...state, hasMouse: true }
    case TOUCH_ACTION:
      return { ...state, hasTouch: true }
    case SET_MODE:
      ReactGA.event({
        category: 'App',
        action: 'Switch Mode',
        label: payload.mode
      }, ['app'])
      return { ...state, mode: payload.mode }
    case LOCATION_CHANGE:
      if(hackyDedupAnalytics !== payload.pathname){
        hackyDedupAnalytics = payload.pathname
        ReactGA.pageview(payload.pathname, ['app'])
      }
      if(payload.hash.match(/^#t([\w-_]*)/)) return { ...state, mode: 'discuss' }
      if (state.mode === 'edit') return { ...state, mode: 'view' }
      else return state
    default:
      return state
  }
}
